import * as Sentry from '@sentry/react';

const InitialiseSentry = () => {
  try {
    Sentry.init({
      defaultIntegrations: false,
      dsn: 'https://40f5541b2dff43e3a23e52fb83bcd544@sentry.blue-zinc.com/2'
    });
  } catch (e) {
    console.error(e);
  }
};

export default InitialiseSentry;
